// extracted by mini-css-extract-plugin
export var table = "_wj-0";